import React from 'react'
import UsersPage from './Users'

const Users = () => (
    <UsersPage/>
)

export default Users
